import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { Location } from '@angular/common';
import * as moment from "moment";

@Component({
  selector: 'app-informationblockdetail',
  templateUrl: './informationblockdetail.page.html',
  styleUrls: ['./informationblockdetail.page.scss'],
})
export class InformationblockdetailPage implements OnInit {
  blockForm: FormGroup;
  informationBlock: any = {};
  tempInformationBlock: any = {}
  informationBlocks: any = {};
  informationBlockId: any;
  locale: any;

  tempLocale: any;

  controlStatus: any = {
    VideoURL: false,
  };


  allLocales: any = []
  moduleList: any = []

  showPage: boolean = false;
  submitted: boolean = false;
  showDelete: boolean = false;


  config: any = {
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Roboto', 'sans-serif;', 'Times New Roman', 'Verdana'],
    height: 300,
    toolbar: [
      ['headline', ['style']],
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['picture','video', 'link']],
      ['table', ['table']]
    ]
  };



  breadcrumb: any = {
    InformationblockDetail: null
  }


  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService,
    private location: Location) { }

  ngOnInit() {
    this.blockForm = this.formBuilder.group({
      Module: [''],
      Title: ['', Validators.required],
      Description: ['',  Validators.required],
      VideoURL: ['', Validators.pattern(/(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/)]
    });
  }

  ionViewDidEnter() {

    this.informationBlockId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    if(this.locale == 1043) {
      this.config.lang = 'nl-NL';
    }
    this.tempLocale = this.locale;
    if (this.informationBlockId == '0') {
      this.informationBlockId = null;
    }
    if (this.informationBlockId) {
      this.getInformationBlockDetails();
    }else{
       this.getInfo()
      this.informationBlock = {
      VideoURL: '',
      Translations : [{
          Title: '',
          Description: '',
          LocaleId: this.locale,
        }]
      }
      this.blockForm.patchValue({
        Module: 'e00d9083-335a-4b6d-8b6a-06015b81bf2a',
      })
      this.showPage = true
    }
  }

  async getInfo(){
    await this.getModuleList();
   await this.getLocales();
  }


  async getLocales() {
    try {
      let localeData = await this._apiService.getLocales('', '', '', 1, 0);
      this.allLocales = localeData.body;
      for (let i = 0; i < this.allLocales.length; i++) {
        if (this.allLocales[i].LocaleIconURL == 'flag-icon-nl') {
          this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
        }
        if (this.allLocales[i].LocaleIconURL == 'flag-icon-gb') {
          this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
        }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }



  async getInformationBlockDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getInformationBlockDetails(this.informationBlockId);
      this.informationBlock = res.body;
      if(this.informationBlock.ModuleName == 'Module_DocumentGenerator'){
        this.showDelete = true;
      }else{
        this.showDelete = false;
      }

      let temp = this.informationBlock.Translations.find(x => x.LocaleId == this.locale);

      this.breadcrumb.InformationblockDetail = temp.Title;
      this.tempInformationBlock = this.informationBlock;
      await this.getLocales()
      await this.getModuleList()
      this._commonService.log(this.informationBlock, this._commonService.LOG);

      this.blockForm.patchValue({
        Title: temp.Title,
        Module: this.informationBlock.ModuleId,
        Description: temp.Description,
        VideoURL: this.informationBlock.VideoURL,
      });
      this._commonService.dismiss();
      this.showPage = true;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }

  get f() { return this.blockForm.controls; }

  async onSubmit() {
    let a;
    let b;
    this.submitted = true;
    // stop here if form is invalid
    if (this.blockForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    this._commonService.presentLoading();
    try {
      let informationBlock = this.informationBlock.Translations.find(x => x.LocaleId == this.locale);
      informationBlock.Title = this.blockForm.value.Title;
      informationBlock.Description = this.blockForm.value.Description ? this.blockForm.value.Description == "<p><br><p>" || this.blockForm.value.Description == "<br>" ? null : this.blockForm.value.Description : null;
      a = this.blockForm.value.VideoURL;
      if(a!=null && a!='')
      {       if (a.includes("https://www.youtube.com/watch?v=")) {
        b = a.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
      } else if (a.includes("https://drive.google.com/file")) {
        b = a.replace("/view", "/preview");
      } else {
        b = a;
      }}else{
        b = this.blockForm.value.VideoURL;
      }

      this.informationBlock.VideoURL = b ? b : null;
      this.informationBlock.ModuleId= this.blockForm.value.Module
      this.informationBlock.PageBlockLocation = null
      let res = await this._apiService.postInformationBlock(this.informationBlock)
      if (res.id) {
        this.informationBlockId = res.id;
        this.informationBlock.InformationBlockId = this.informationBlockId;
        this.location.replaceState('maintenance/informationblock/' + this.informationBlockId);
      }
      this.breadcrumb.InformationblockDetail = this.blockForm.value.Title;
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.dismiss()
    } catch (error) {
      if(error.status >= 500 && error.status < 600){
        let temp = this.tempInformationBlock.Translations.find(x => x.LocaleId == this.locale);
        this.breadcrumb.InformationblockDetail = temp.Title;
        this.blockForm.patchValue({
          Title: temp.Title,
          Module: this.informationBlock.ModuleId,
          Description: temp.Description,
          VideoURL: this.informationBlock.VideoURL,
        });

      }
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  delete() {
    this._commonService.presentAlertConfirm()
    .then(async (res) => {
      try {
        this._commonService.presentLoading();
        await this._apiService.deleteInformationBlock(this.informationBlockId);
        this._commonService.dismiss();
        this._commonService.log(res, this._commonService.LOG);
        this.goBack();
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    })
    .catch((err) => {
      this._commonService.log(err, this._commonService.LOG);
    })
  }

  changeLocale() {
    if (this.showPage){
      if (this.informationBlockId && this.informationBlock.Translations) {
        let tempInfo = this.informationBlock.Translations.find(x => x.LocaleId == this.tempLocale);
        tempInfo.Title = this.blockForm.value.Title;
        tempInfo.Description = this.blockForm.value.Description;
        this.tempLocale = this.locale;
        let info = this.informationBlock.Translations.find(x => x.LocaleId == this.locale);
        if(info){
          this.blockForm.patchValue({
            Title: info.Title,
            Description: info.Description,
          });
        }else{
          this.informationBlock.Translations.push({
            Title: '',
            Description: '',
            LocaleId: this.locale,
          });
          this.blockForm.controls['Title'].reset();
          this.blockForm.controls['Description'].reset();
        }
      } else {
        let tempInfo = this.informationBlock.Translations.find(x => x.LocaleId == this.tempLocale);
        if (tempInfo) {
          tempInfo.Title = this.blockForm.value.Title;
          tempInfo.Description = this.blockForm.value.Description
          this.tempLocale = this.locale;

          let info = this.informationBlock.Translations.find(x => x.LocaleId == this.locale);
          if (info) {
            this.blockForm.patchValue({
              Title: info.Title,
              Description: info.Description,
            });
          }
          else {
            this.informationBlock.Translations.push({
              Title: '',
              Description: '',
              LocaleId: this.locale,
            });
            this.blockForm.controls['Title'].reset();
            this.blockForm.controls['Description'].reset();
            this.tempLocale = this.locale;
          }
        }
      }
    }
  }


  onBlurMethod(controlName){
    if(controlName == 'VideoURL'){
      this.controlStatus.VideoURL = true
    }

   }

   onFocusMethod(controlName){
     if(controlName == 'VideoURL'){
       this.controlStatus.VideoURL = false
     }
   }





  goBack() {
    this.location.back();
  }

  onChangeBreadcrumb() {
    this.breadcrumb.InformationblockDetail = this.blockForm.value.Title;
  }

  async getModuleList() {
    try {
      let res = await this._apiService.getModules('','','',1,0)
      this.moduleList = res.body
    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onChangeModule(){}


  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;


    }

  }


}
